module.exports = __webpack_public_path__ + "static/media/cash.19ae4356.svg";